module.exports = __webpack_public_path__ + "img/kokuban.96c2f62c.jpg";